import { parseLocalDateString } from '@domgen/shared/utils/date/parseLocalDateString';

const RECENT_APPLIANCE_MONTHS = 3;

/**
 * @description Bank Account promotion copy by appliance age: under 3 months since arrival 20% off,
 * from 3 months on 50% off. Undefined without a valid arrival date, so the SDK copy stays.
 */
export const getAchPromotionText = (arrivalDate?: string, today = new Date()) => {
  if (!arrivalDate) return undefined;

  let arrival: Date;
  try {
    arrival = parseLocalDateString(arrivalDate);
  } catch {
    return undefined;
  }

  // Kept within the month 3 months on, as Date rolls a missing day (e.g. 30 February) into the next
  const recentUntilMonth = arrival.getMonth() + RECENT_APPLIANCE_MONTHS;
  const lastDayOfRecentUntilMonth = new Date(
    arrival.getFullYear(),
    recentUntilMonth + 1,
    0,
  ).getDate();
  const recentUntil = new Date(
    arrival.getFullYear(),
    recentUntilMonth,
    Math.min(arrival.getDate(), lastDayOfRecentUntilMonth),
  );

  return today < recentUntil ? '20% off for 6 months' : '50% off for 6 months';
};
